<template>
    <section class="py-2 text-center container">
      <div class="row py-lg-2">
        <div class="col-lg-6 col-md-8 mx-auto">
          <h1 class="fw-light">おこさまぷれ～と。</h1>
          <h5>非公式ふぁんさいと</h5>
          <p class="text-body-secondary text-left">
            サイト構成は編集中です。開発途中のβ版なのでよく壊れるかもしれません。
            過去の毎日投稿を追えるように動画の月別ソート表示を主機能としているので、
            とりあえずそこだけ使えるように調整中です。<br>
          </p>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'WelcomeBoard'
}
</script>